'use client';
import { useState, useEffect } from 'react';
import { RenderRTE } from '@/components/RenderRTE';
import { Document } from '@contentful/rich-text-types';

interface Props {
    asW2?: boolean;
    text?: Document;
}

export default function ClientTextContent({ text, asW2 }: Props) {
    const [textData, setTextData] = useState<Document | undefined>();

    useEffect(() => {
        setTextData(text);
    }, [text]);

    return (
        <>{textData ? <RenderRTE contentfulDoc={textData} asW2={asW2} /> : <div style={{ minHeight: '80vh' }}></div>}</>
    );
}
